// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ss-0";
export var checkoutRateBadgeLink = "_ss-1";